import { ref, toRefs, computed, reactive, nextTick, watch } from 'vue'

export const useAccountTable = () => {
  const ref_MultipleTable = ref(null)
  const tableModel = reactive({
    accountList: [],
    selectList: []
  })

  const selectedIds = computed(() => tableModel.selectList.map((item) => item.id))

  function onTableRowClick(row, isAll = false) {
    const rowCheck = selectedIds.value.includes(row.id)
    let newValue = tableModel.selectList

    if (isAll) {
      if (!rowCheck) {
        newValue.push(row)
      }
    } else {
      if (rowCheck) {
        newValue = newValue.filter((r) => r.id !== row.id)
      } else {
        newValue = [row].concat(newValue)
      }
    }

    tableModel.selectList = newValue
    nextTick(initCheckStates)
  }
  function onSelectChange(selection, row) {
    onTableRowClick(row)
  }

  /**
   * @description: 全选或取消时处理
   * @param {*} selection
   * @return {*}
   */
  function onSelectAllChange(selection) {
    if (!selection.length) {
      // 如果取消全选，去掉当前分页选中的值
      const pageRowIds = tableModel.accountList.map((r) => r.id)
      tableModel.selectList = tableModel.selectList.filter((r) => !pageRowIds.includes(r.id))
      nextTick(initCheckStates)
      return
    }
    selection.forEach((row) => {
      onTableRowClick(row, true)
    })
  }

  function initCheckStates() {
    ref_MultipleTable.value?.clearSelection()
    tableModel.accountList.forEach((row) => {
      ref_MultipleTable.value.toggleRowSelection(row, selectedIds.value.includes(row.id))
    })
  }
  return { ...toRefs(tableModel), ref_MultipleTable, selectedIds, onTableRowClick, onSelectChange, onSelectAllChange, initCheckStates }
}
